export class ProgressBarColors {
  public static readonly completed = 'var(--md-sys-color-primary)'
  public static readonly progress = 'var(--md-sys-color-primary-fixed-dim)'
  public static readonly readyForProduction = 'var(--md-sys-color-error)'
  public static readonly onHold = 'var(--md-sys-color-outline)'
}
